





















































































































































import { Component, Vue, Inject } from "vue-property-decorator";
import { AnagraficaRequest } from "@/data/models/anagrafica.model";
import { SelectOption } from "@/data/models/select-option.model";
import {
  Specializzazione,
  SpecializzazioneAttivita,
  SpecializzazioneVoce,
} from "@/data/models/specializzazione.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { SpecializzazioneService } from "@/data/services/specializzazione.service";
import { date2Num } from "yellowfin-ui-lib";

@Component({})
export default class AnagraficaSearch extends Vue {
  @Inject("SpecializzazioneService")
  specializzazioneService!: SpecializzazioneService;
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;

  searchparam: AnagraficaRequest;
  get showsettore() {
    return (process.env.VUE_APP_SETTORE_HIDE as string) === "false";
  }

  specs: Specializzazione[] = [];
  specsII: SpecializzazioneVoce[] = [];
  specsIII: SpecializzazioneAttivita[] = [];

  lauree: SelectOption[] = [];
  comuni: SelectOption[] = [];
  occupazioni: SelectOption[] = [];
  elenchi: SelectOption[] = [];

  iscdal: Date | null = null;
  iscal: Date | null = null;

  constructor() {
    super();
    this.searchparam = new AnagraficaRequest();
  }

  get config() {
    const conf = process.env.VUE_APP_SEARCH;
    return conf ? JSON.parse(conf) : {};
  }

  beforeMount() {
    this.specializzazioneService
      .getAll()
      .then((result) => (this.specs = result));
    if (this.config["laurea"]) {
      this.anagraficaService
        .getMenu("laurea")
        .then((result) => (this.lauree = result));
    }
    if (this.config["comune"]) {
      this.anagraficaService
        .getMenu("comune")
        .then((result) => (this.comuni = result));
    }
    if (this.config["occupazione"]) {
      this.anagraficaService
        .getMenu("occupazione")
        .then((result) => (this.occupazioni = result));
    }
    if (this.config["idelenco"]) {
      this.anagraficaService
        .getMenu("elenco")
        .then((result) => (this.elenchi = result));
    }
  }

  onSpec1Change() {
    this.searchparam.spec2 = "";
    this.searchparam.spec3 = "";
    if (!this.searchparam.spec1) return [];
    const spec = this.specs.filter((s) => s.nome === this.searchparam.spec1);
    if (spec[0].specII) {
      this.specsII = spec ? spec[0].specII : [];
    } else if (spec[0]) {
      this.specializzazioneService
        .getSpecII(spec[0].id)
        .then((result) => (this.specsII = result));
    }
  }

  onSpec2Change() {
    this.searchparam.spec3 = "";
    if (!this.searchparam.spec2) return [];
    const spec = this.specsII.filter((s) => s.nome === this.searchparam.spec2);

    if (spec[0].specIII) {
      this.specsIII = spec ? spec[0].specIII : [];
    } else if (spec[0]) {
      this.specializzazioneService
        .getSpecIII(spec[0].id)
        .then((result) => (this.specsIII = result));
    }
  }

  search() {
    this.searchparam.iscdal = this.iscdal
      ? `${date2Num(this.iscdal)}`
      : undefined;
    this.searchparam.iscal = this.iscal ? `${date2Num(this.iscal)}` : undefined;
    this.$emit("search", this.searchparam);
  }

  reset() {
    this.searchparam = new AnagraficaRequest();
    this.iscdal = null;
    this.iscal = null;
    this.search();
  }
}
